import { WeatherStationRealTimeModel } from '../models/weather-station-real-time';

export class WeatherStationRealTimeAdapter {
  static fromApi(response: any): WeatherStationRealTimeModel {
    const data = response.data || response;

    return {
      id: data.id,
      hashId: data.hashId,
      identification: data.identification,
      generationDate: data.generationDate,
      generationTime: data.generationTime,
      temp: data.temp,
      tempMin: data.tempMin,
      tempMax: data.tempMax,
      rain: data.rain,
      dataSource: data.dataSource,
      stationId: data.stationId,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }
}
